import React from 'react';
import {Link} from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import {Loading} from 'Components/Partials';
import {Questions as QuestionComponent} from 'Components/MainStage';
import SocketIndicator from 'Components/Utilities/SocketIndicator';

import User from 'Services/User';
import {translation} from 'Services/TranslationHelpers';

import Base from './Base';

export default class Questions extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = false;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, currentSession} = this.state;

        return (
            <Authenticated>
                <div className="flex justify-center items-center text-center uppercase text-2xl font-bold mt-8">
                    {translation('main_stage_frontend','live')}

                    <div className="ml-2">
                        <SocketIndicator />
                    </div>
                </div>

                {currentSession && 
                    <div className="flex justify-center items-center text-center uppercase text-2xl font-bold mt-2 mb-4">
                        {currentSession.title}
                    </div>
                }

                <div className="p-4 md:px-24 pt-12 lg:px-48 mx-auto pb-6 lg:pb-64 px-4 relative z-10">
                    {working && (<Loading/>)}

                    {!working && (
                        <React.Fragment>
                            {!currentSession &&
                                <div className="bg-main-stage-comments overflow-hidden rounded-md sm:shadow w-full py-5 text-white text-center">
                                    {translation('main_stage_frontend', 'no_sessions_live_come_back_later')}
                                </div>
                            }

                            {currentSession && (
                                <div>
                                    <div className="flex">
                                        {this.renderQuestion()}
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderQuestion
     * @return {JSX.Element}
     */
    renderQuestion = () => (
        <QuestionComponent readOnly={true} sessionId={this.state.currentSession.id} />
    );
}
